var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLlave2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "210px",
    height: "32px",
    viewBox: "0 0 207 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 207.074219 13.714844 L 31.886719 13.714844 C 30.746094 5.941406 24.125 0 16.058594 0 C 7.230469 0 0.0742188 7.160156 0.0742188 16 C 0.0742188 24.839844 7.230469 32 16.058594 32 C 24.125 32 30.746094 26.058594 31.886719 18.285156 L 207.074219 18.285156 Z M 16.058594 27.429688 C 9.742188 27.429688 4.640625 22.324219 4.640625 16 C 4.640625 9.675781 9.742188 4.570312 16.058594 4.570312 C 22.375 4.570312 27.472656 9.675781 27.472656 16 C 27.472656 22.324219 22.375 27.429688 16.058594 27.429688 Z M 16.058594 27.429688 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlave2);
export default __webpack_public_path__ + "static/media/llave2.902ab6721358d7fe6758cf147a05bb25.svg";
export { ForwardRef as ReactComponent };